import { IActionEvent } from 'app/api/event/model'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { SectionBase } from 'app/components/common/SectionBase'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { convertColumnTable } from 'app/components/tables/BaseTableReport/hook'
import { FORMAT_DD_MM_YYYY_HH_MM } from 'app/constant'
import { RenderText } from 'app/containers/EventManagement/hook'
import { useGetAllActionByMember } from 'app/react-query/hook/event'
import { useAppSelector } from 'app/redux/hooks'
import { DateUtil } from 'parkway-web-common'
import { useMemo } from 'react'
interface IData extends IActionEvent {
  key: number
}
export const ActionJoin = () => {
  const user = useAppSelector(state => state?.user)?.profile
  const { data: response, isLoading } = useGetAllActionByMember({
    member_id: user?.member?.id,
  })

  const data = useMemo(() => {
    return response?.data?.map((item, index) => {
      return {
        ...item,
        key: index + 1,
        index: index + 1,
      }
    })
  }, [response])

  return (
    <SectionBase title="Tất cả hoạt động/sự kiện đã tham gia">
      <BaseTableManagement
        dataSource={data}
        columns={[
          convertColumnTable<IData>({
            title: 'STT',
            key: 'key',
            classNameWidthColumnOverwrite: 'number-column',
            fixed: 'left',
            render: value => {
              return (
                <BaseText children={value} fontWeight="medium" opacity="0.7" />
              )
            },
          }),
          convertColumnTable<IData>({
            title: 'Tên hoạt động',
            key: 'activity',
            classNameWidthColumnOverwrite: 'big-column',
            fixed: 'left',
            render: (_, record) => {
              return (
                <BaseText
                  children={record?.name}
                  fontWeight="semibold"
                  colorText={'statesGreenColor'}
                />
              )
            },
          }),
          convertColumnTable<IData>({
            title: 'Sự kiện',
            key: 'event',
            classNameWidthColumnOverwrite: 'big-column',
            render: (_, record) => {
              return (
                <BaseSpace size={8}>
                  <BaseText
                    children={record?.event?.name_event}
                    fontWeight="medium"
                    opacity="0.7"
                  />
                  <BaseText
                    fontWeight="medium"
                    opacity="0.7"
                    children={
                      <RenderText text={record?.event?.description ?? ''} />
                    }
                  />
                </BaseSpace>
              )
            },
          }),

          convertColumnTable<IData>({
            title: 'Thời gian đăng ký',
            key: 'event',
            classNameWidthColumnOverwrite: 'big-column',
            render: (_, record) => {
              return (
                <BaseText
                  children={`${DateUtil.formatDate(
                    record?.event?.time_register_start ?? '',
                    FORMAT_DD_MM_YYYY_HH_MM,
                  )} - ${DateUtil.formatDate(
                    record?.event?.time_register_end ?? '',
                    FORMAT_DD_MM_YYYY_HH_MM,
                  )}`}
                  fontWeight="medium"
                  colorText="statesGreenColor"
                />
              )
            },
          }),
          convertColumnTable<IData>({
            title: 'Thời gian diễn ra sự kiện',
            key: 'event',
            classNameWidthColumnOverwrite: 'big-column',
            render: (_, record) => {
              return (
                <BaseText
                  children={`${DateUtil.formatDate(
                    record?.event?.time_start ?? '',
                    FORMAT_DD_MM_YYYY_HH_MM,
                  )} - ${DateUtil.formatDate(
                    record?.event?.time_end ?? '',
                    FORMAT_DD_MM_YYYY_HH_MM,
                  )}`}
                  fontWeight="medium"
                  opacity="0.7"
                />
              )
            },
          }),
        ]}
        loading={isLoading}
        scroll={{
          x: true,
          y: data?.length && data?.length > 5 ? 450 : undefined,
        }}
      />
    </SectionBase>
  )
}
